import React from "react"
import { graphql, useStaticQuery } from "gatsby"

import Grid from "../shared/grid"
import {
  DataTypeImage,
  DataTypeIndicator,
  Title,
  Body,
  Properties,
  DividingLine,
  PropertiesWrapper,
} from "./data-model.card.style"

const DataModelCard = ({ image, dataType, title, body, properties }) => {
  const { moleculeIcon } = useStaticQuery(graphql`
    query {
      moleculeIcon: file(
        relativePath: {
          eq: "1_SOLUTIONS/Developer Tools - Internal Pages/Exports/Desktop/molecule_icon.svg"
        }
      ) {
        publicURL
      }
    }
  `)
  return (
    <Grid>
      <DataTypeImage src={image} />
      <DataTypeIndicator>
        <img src={moleculeIcon.publicURL} alt="" />
        {dataType}
      </DataTypeIndicator>
      <Title>{title}</Title>
      <Body>{body}</Body>
      <Properties>Properties</Properties>
      <DividingLine />
      <PropertiesWrapper>
        {properties.map(element => (
          <li key={element}>{element}</li>
        ))}
      </PropertiesWrapper>
    </Grid>
  )
}

export default DataModelCard
